/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:33:01+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-28T14:53:18+08:00
 */
 import { EmployeeManagement } from '../constants/employee-management-constants.js';
 import rosterService from '../services/EmployeeManagement/roster-service.js';
 import { message } from 'antd';
 import _util from '../utils/index.js';
 import { push } from 'react-router-redux';
 import contractManagementService from '../services/EmployeeManagement/contract-management-service.js';
 import certificateManagementService from '../services/EmployeeManagement/certificate-manage-service.js';
 import addressListService from '../services/EmployeeManagement/address-list-service.js';
 import staffBirthdayService from '../services/EmployeeManagement/staff-birthday-service.js';
 import reportFormsService from '../services/EmployeeManagement/report-forms-service.js';
 import airticketAllowanceService from "../services/SalaryAllowance/airticket-allowance-service";
 import housingAllowanceService from "../services/SalaryAllowance/housing-allowance-service";

 // 花名册
 export function fetchEmployeesListAll (params) {
     return (dispatch) => {
         dispatch({
             type: EmployeeManagement.ActionTypes.FETCHALLSUCCESS,
             payload: {
                 fetching: true,
                 actionStatus: false
             }
         })
         rosterService.fetchEmployeesListAll(params, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.FETCHALLSUCCESS,
                     payload: {
                         employeeListAll: res.data,
                         fetching: false,
                     }
                 })
             } else {
                 // 如何更好的抛出异常。。。。每次都 throw 一个 新构建的 Error 类 明显是 一个很糟糕的方案 Need to Think & Modify
                 throw new Error('获取信息失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHFAILALLSUCCESS,
                 payload: {
                     err,
                     fetching: false,
                 }
             })
         })
     }
 }
 export function fetchEmployeesList (params) {
     return (dispatch) => {
         dispatch({
             type: EmployeeManagement.ActionTypes.FETCHDATA,
             payload: {
                 fetching: true,
                 actionStatus: false
             }
         })
         rosterService.fetchEmployeesList(params, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.FETCHDATA,
                     payload: {
                         employeeList: res.data,
                         fetching: false,
                     }
                 })
             } else {
                 // 如何更好的抛出异常。。。。每次都 throw 一个 新构建的 Error 类 明显是 一个很糟糕的方案 Need to Think & Modify
                 throw new Error('获取信息失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHFAILURE,
                 payload: {
                     err,
                     fetching: false,
                 }
             })
         })
     }
 }
export function fetchEmployeesUserList(gets) {
    // console.log(gets)
 return dispatch => {
  rosterService.fetchEmployeesUserList(gets, res => {
   // console.log(res);
   dispatch({
    type: EmployeeManagement.ActionTypes.FETCHEMPLOYEEUSERDATA,
    payload: {
     employeeUserList: res.data
   }
 });
 }, err => {});
}
}

export function fetchEmployeesGroupList(gets) {
    // console.log(gets)
 return dispatch => {
  rosterService.fetchEmployeesList(gets, res => {
   // console.log(res);
   dispatch({
    type: EmployeeManagement.ActionTypes.FETCHEMPLOYEEGROUPDATA,
    payload: {
     employeeGroupList: res.data
   }
 });
 }, err => {});
}
}
 // export function fetchEmployeesGroupList (params) {
 //     return (dispatch) => {
 //         dispatch({
 //             type: EmployeeManagement.ActionTypes.FETCHEMPLOYEEGROUPDATA,
 //             payload: {
 //                 fetching: true,
 //                 actionStatus: false
 //             }
 //         })
 //         rosterService.fetchEmployeesList(params, (res) => {
 //            console.log(res.data);
 //             if (res.data) {
 //                 dispatch({
 //                     type: EmployeeManagement.ActionTypes.FETCHEMPLOYEEGROUPDATA,
 //                     payload: {
 //                         employeeGroupList: res.data,
 //                         fetching: false,
 //                     }
 //                 })
 //             } else {
 //                 // 如何更好的抛出异常。。。。每次都 throw 一个 新构建的 Error 类 明显是 一个很糟糕的方案 Need to Think & Modify
 //                 // throw new Error('获取信息失败')
 //                 _util.errorTips('获取信息失败,' + res.data.Errors[0])
 //             }
 //         }, (err) => {
 //             dispatch({
 //                 type: EmployeeManagement.ActionTypes.FETCHEMPLOYEEGROUPDATA,
 //                 payload: {
 //                     err,
 //                     fetching: false,
 //                 }
 //             })
 //         })
 //     }
 // }

 export function fetchEmployeeInit (params) {
     return (dispatch) => {
         rosterService.fetchEmployeeInit(params, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                     payload: {
                         employeeCreateInit: res.data
                     }
                 })
             } else {
                 throw new Error('获取信息失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHFAILURE,
                 payload: {
                     err
                 }
             })
         })
     }
 }

 export function fetchExportColumn (params) {
     return dispatch => {
         rosterService.fetchExportColumn(params, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.FETCHEXPORTCOLUMNSUCCESS,
                     payload: {
                         exportColumns: res.data
                     }
                 })
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHEXPORTCOLUMNFAILURE
             })
         })
     }
 }

 export function createEmployee (data) {
     return (dispatch) => {
         rosterService.createEmployee(data, (res) => {
             if (res.data.Success) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.CREATESUCCESS,
                     payload: {
                         actionStatus: true,
                         // employeeList: res.data.Data
                     }
                 })
                 _util.successTips('创建用户成功')
             } else {
                 _util.errorTips('创建用户失败,' + res.data.Errors[0])
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.CREATEFAILURE,
                 payload: {
                     actionStatus: false
                 }
             })
             _util.errorTips('创建用户失败')
         })
     }
 }
 export function deleteEmployees (data,callback) {
     return (dispatch) => {
         rosterService.deleteEmployees(data, (res) => {
             if (res.data.Success) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.DELETESUCCESS,
                     payload: {
                         actionStatus: true,
                     }
                 })
                 callback(res)
                 _util.successTips('删除用户成功')
                 
             } else {
                 callback(res)
                 throw new Error('删除员工失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.DELETEFAILURE,
                 payload: {
                     actionStatus: false
                 }
             })
             _util.errorTips('删除用户失败')
         })
     }
 }

 export function exportEmployees (data) {
     return (dispatch) => {
         rosterService.exportEmployees(data, (res) => {
             if (res.data.Success) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.EXPORTEMPLOYEESSUCCESS,
                     payload: {
                         fileUrl: res.data.Message
                     }
                 })
                 message.success('导出成功')
             } else {
                 throw new Error('导出员工失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.EXPORTEMPLOYEESFAILURE
             })
             //message('导出失败')
             _util.errorTips('导出失败');
         })
     }
 }
 export function clearFileUrl () {
     return dispatch => {
         dispatch({
             type: EmployeeManagement.ActionTypes.EMPTY,
             payload: {
                 fileUrl: null
             }
         })
     }
 }

 export function linkToNewRouter (url) {
     return dispatch => {
         dispatch(push(url))
     }
 }

 export function fetchEmployeeDetail (id) {
     return dispatch => {
         rosterService.fetchEmployeeDetail(id, (res) => {
             console.log(res)
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                 payload: {
                     employeeDetail: res.data,
                     fetchDetail: false
                 }
             })
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHFAILURE,
             })
         })
     }
 }

 export function editEmployee (data) {
     return dispatch => {
         rosterService.editEmployee(data, (res) => {
             // console.log(`编辑员工结果:${JSON.stringify(res)}`);
             if (res.data && res.data.Success) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.UPDATESUCCESS,
                 });
                 _util.successTips('更新成功')
             } else {
                dispatch({
                    type: EmployeeManagement.ActionTypes.UPDATEFAILURE,
                })
                _util.errorTips(res.data.Errors[0]);
             }
         }, (err) => {
            // console.log(`编辑员工结果:${JSON.stringify(err)}`);
             dispatch({
                 type: EmployeeManagement.ActionTypes.UPDATEFAILURE,
             })
             _util.errorTips('更新失败')
         })
     }
 }
// 以下为丢失信息
// 公司内兼任相关
export function getPartTimeInit (params) {
   return dispatch => {
       rosterService.getPartTimeInit(params, (res) => {
           if (res.data) {
               dispatch({
                   type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                   payload: {
                       partTimeInit: res.data
                   }
               })
           }
       }, (err) => {
           dispatch({
               type: EmployeeManagement.ActionTypes.FETCHFAILURE,
               payload: {
                   err
               }
           })
       })
   }
}
export function createPartTime (data) {
   return dispatch => {
       rosterService.createPartTime(data, (res) => {
           if (res.data.Success) {
               dispatch({
                   type: EmployeeManagement.ActionTypes.CREATESUCCESS,
                   payload: {
                       fetchDetail: true
                   }
               })
               _util.successTips('提交成功')
           } else {
               throw new Error()
           }
       }, (err) => {
           dispatch({
               type: EmployeeManagement.ActionTypes.CREATEFAILURE,
               payload: {
                   err
               }
           })
           _util.errorTips('提交失败')
       })
   }
}

export function deletePartTime (data, cb) {
    return dispatch => {
        rosterService.deletePartTime(data, cb, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.DELETESUCCESS,
                    fetchDetail: true
                })
                if (typeof cb === 'function') cb();
                _util.successTips('删除成功')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.DELETEFAILURE
            })
            _util.errorTips('删除失败')
        })
    }
}

export function updatePartTime (data) {
    return dispatch => {
        rosterService.updatePartTime(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.UPDATESUCCESS,
                    fetchDetail: true
                })
            }
            _util.successTips('更新成功')
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.UPDATEFAILURE
            })
            _util.errorTips('更新失败')
        })
    }
}

export function createEmployeeEducation (data) {
   return dispatch => {
       rosterService.createEmployeeEducation(data, (res) => {
           if (res.data.Success) {
               dispatch({
                   type: EmployeeManagement.ActionTypes.CREATESUCCESS,
                   payload: {
                       fetchDetail: true
                   }
               })
               _util.successTips('提交成功')
           }
       }, (err) => {
           dispatch({
               type: EmployeeManagement.ActionTypes.CREATEFAILURE,
           })
           _util.errorTips('提交失败')
       })
   }
}

export function deleteEmployeeEducation (data, cb) {
    return dispatch => {
        rosterService.deleteEmployeeEducation(data, cb, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.DELETESUCCESS
                })
                if (typeof cb === 'function') cb();
                _util.successTips('删除成功')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.DELETEFAILURE,
            })
            _util.errorTips('删除失败')
        })
    }
}

export function updateEmployeeEducation (data) {
    return dispatch => {
        rosterService.updateEmployeeEducation(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.UPDATESUCCESS,
                    payload: {
                        fetchDetail: true
                    }
                })
                _util.successTips('更新成功')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.UPDATEFAILURE
            })
            _util.errorTips('更新失败')
        })
    }
}

export function createEmployeeExperience (data) {
   return dispatch => {
       rosterService.createEmployeeExperience(data, (res) => {
           if (res.data.Success) {
               dispatch({
                   type: EmployeeManagement.ActionTypes.CREATESUCCESS,
                   payload: {
                       fetchDetail: true
                   }
               })
               _util.successTips('提交成功')
           }
       }, (err) => {
           dispatch({
               type: EmployeeManagement.ActionTypes.CREATEFAILURE,
           })
           _util.errorTips('提交失败')
       })
   }
}

export function deleteEmployeeExperience (data, cb) {
    return dispatch => {
        rosterService.deleteEmployeeExperience(data, cb, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.DELETEFAILURE,
                })
                if (typeof cb === 'function') cb();
                _util.successTips('删除成功')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.DELETEFAILURE
            })
            _util.errorTips('删除失败')
        })
    }
}

export function updateEmployeeExperience (data) {
    return dispatch => {
        rosterService.updateEmployeeExperience(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: {
                        type: EmployeeManagement.ActionTypes.UPDATESUCCESS,
                        payload: {
                            fetchDetail: true
                        }
                    }
                })
            }
            _util.successTips('更新成功')
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.UPDATEFAILURE,
            })
            _util.errorTips('更新失败')
        })
    }
}

 export function leaveJobEmployee (data) {
     return dispatch => {
         rosterService.leaveJobEmployee(data, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.UPDATESUCCESS,
                     payload: {
                         actionStatus: true
                     }
                 })
             }
             _util.successTips('更新成功')
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.UPDATEFAILURE,
             })
             _util.errorTips('更新失败')
         })
     }
 }

export function emptyEmployeeDetail () {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.EMPTY,
            payload: {
                employeeDetail: null
            }
        })
    }
}

export function fetchAllEmployees (params) {
    return dispatch => {
        rosterService.fetchAllEmployees(params, (res) => {
            if (res.data) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                    payload: {
                        allEmployees: res.data
                    }
                })
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHFAILURE,
                payload: {
                    err
                }
            })
        })
    }
}

// 合同管理
export function fetchContractList(page = 1) {
    return dispatch => {
        contractManagementService.fetchContractList(page, res => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHCONTRACTLISTSUCCESS,
                payload: {
                    constractListStatus: true,
                    constractList: res.data.Data,
                    constractTotal: res.data.Total,
                    constractPageSize: res.data.PageSize,
                    constractPage: res.data.Page
                }
            })
        }, err => {})
    }
}
// export function fetchContractEmployee(gets) {
//     return dispatch => {
//         contractManagementService.fetchContractEmployee(gets, res => {
//             dispatch({
//                 type: EmployeeManagement.ActionTypes.FETCHCONTRACTEMPLOYEESUCCESS,
//                 payload: {
//                     constractEmployeeStatus: true,
//                     constractEmployee: res.data.Data,
//                     constractEmployeeTotal: res.data.Total
//                 }
//             })
//         }, err => {})
//     }
// }
export function fetchContractDetail(employee_id) {
    return dispatch => {
        contractManagementService.fetchContractDetail(employee_id, res => {
            console.log(res);
            let contractUserDetail = {
                id: res.data.employee.id,
                real_name: res.data.employee.real_name,
                id_number: res.data.employee.id_number,
                job_number: res.data.employee.job_number,
                department_name: res.data.employee.department_name,
            }
            let contractDetail = res.data.contracts.map(contract => {
                return {
                    id: contract.id,
                    employee_id: contract.employee_id,
                    property_id: contract.property_id,
                    property_name: contract.property_name,
                    status_id: contract.status_id,
                    status_name: contract.status_name,
                    type_id: contract.type_id,
                    type_name: contract.type_name,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    probation_end_date: contract.probation_end_date,
                    is_active: contract.is_active,
                    unedit: true
                }
            });
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHCONTRACTDETAILSUCCESS,
                payload: {
                    contractUserDetail: contractUserDetail,
                    contractDetail: contractDetail,
                    contract_properties: res.data.contract_properties,
                    contract_statuses: res.data.contract_statuses,
                    contract_types: res.data.contract_types,
                    contractDetailStatus: true
                }
            })
        }, err => {})
    }
}
export function toggleEditContract(index) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.TOGGLEEDITCONTRACT,
            payload: {
                index: index
            }
        });
    }
}
export function newContract(newContract) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.NEWCONTRACT,
            payload: {
                newContract: newContract
            }
        });
    }
}

export function deleteContract(contract, index, callback) {
    return dispatch => {
        if (contract.id) {
            contractManagementService.deleteContract({id: contract.id}, res => {
                dispatch({
                    type: EmployeeManagement.ActionTypes.DELETECONTRACT,
                    payload: {
                        index: index
                    }
                });
                if ('function' === typeof callback) {
                    callback(true);
                }
            }, err => {})
        }else{
            dispatch({
                type: EmployeeManagement.ActionTypes.DELETECONTRACT,
                payload: {
                    index: index
                }
            });
            if ('function' === typeof callback) {
                callback(true);
            }
        }
    }
}
export function addContract(contract, index, callback) {
    return dispatch => {
        contractManagementService.addContract(contract, res => {
            console.log(res);
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.ADDCONTRACTSUCCESS,
                    payload: {
                        index: index,
                        id: res.data.ModelId
                    }
                });
                if ('function' === typeof callback) {
                    callback(true, null);
                }
            }else{
                if ('function' === typeof callback) {
                    callback(false, res.data.Errors[0]);
                }
            }
        }, err => {})
    }
}
export function changeContract(item) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.CHANGECONTRACT,
            payload: item
        });
    }
}
export function editContract(contract, index, callback) {
    return dispatch => {
        contractManagementService.editContract(contract, res => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.EDITCONTRACTSUCCESS,
                    payload: {
                        index: index,
                    }
                });
                if ('function' === typeof callback) {
                    callback(true, null);
                }
            }else{
                if ('function' === typeof callback) {
                    callback(false, res.data.Errors[0]);
                }
            }
        }, err => {})
    }
}
export function recoverContract(index, contract) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.RECOVERCONCTRACT,
            payload: {
                index: index,
                contract: contract
            }
        });
    }
}


export function exportContract(callback) {
    return dispatch => {
        contractManagementService.exportContract(res => {
            // console.log(res);
            if (res.data.Success) {
                callback(res.data.Message);
            }else{
                callback(false);
            }
            // dispatch({
            //     type: EmployeeManagement.ActionTypes.FETCHCONTRACTDETAILSUCCESS,
            //     payload: {
            //         constractDetailStatus: true,
            //         constractDetail: res.data.Data,
            //     }
            // })
        }, err => {})
    }
}
export function initContarctAlert() {
    return dispatch => {
        contractManagementService.initContarctAlert(res => {
            // console.log(res);
            dispatch({
                type: EmployeeManagement.ActionTypes.INITCONTRACTALERTSUCCESS,
                payload: {
                    contract_over_alert: res.data.Data[0].contract_over_alert,
                    contract_probation_over_alert: res.data.Data[0].contract_probation_over_alert,
                    certificate_over_alert: res.data.Data[0].certificate_over_alert
                }
            })
        }, err => {})
    }
}
export function contractAlert(posts) {
    return dispatch => {
        contractManagementService.contractAlert(posts, res => {
            console.log(res);
        }, err => {})
    }
}
export function changeContractOverAlert(value) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.CHANGECONTRACTOVERALERT,
            payload: {
                contract_over_alert: value
            }
        })
    }
}
export function changeContractProbationOverAlert(value) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.CHANGECONTRACTPROBATIONOVERALERT,
            payload: {
                contract_probation_over_alert: value
            }
        })
    }
}
export function changeCertificateValue(value) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.CHANGECERTIFICATEVALUE,
            payload: {
                certificate_over_alert: value
            }
        })
    }
}

// 证件管理
export function fetchCertificateList(page = 1) {
    return (dispatch) => {
         certificateManagementService.fetchCertificateList(page, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.FETCHCERTIFICATELISTSUCCESS,
                     payload: {
                         certificateList: res.data.Data,
                         certificateTotal: res.data.Total,
                         certificatePageSize: res.data.PageSize,
                         certificatePage: res.data.Page
                     }
                 })
             } else {
                 // 如何更好的抛出异常。。。。每次都 throw 一个 新构建的 Error 类 明显是 一个很糟糕的方案 Need to Think & Modify
                 throw new Error('获取信息失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHCERTIFICATELISTFAILURE,
                 payload: {
                     err
                 }
             })
         })
     }
}

export function fetchCertificateEmployeeList(gets) {
 return dispatch => {
  certificateManagementService.fetchCertificateEmployeeList(gets, res => {
   // console.log(res);
   dispatch({
    type: EmployeeManagement.ActionTypes.FETCHCERTIFICATEEMPLOYEELISTSUCCESS,
    payload: {
     certificateEmployeePage: res.data.Page,
     certificateEmployeePageSize: res.data.PageSize,
     certificateEmployeeTotalPage:res.data.Total,
     certificateEmployeeList: res.data.Data,
     certificateEmployeeDataStatus: "loaded"
   }
 });
 }, err => {
    dispatch({
         type: EmployeeManagement.ActionTypes.FETCHCERTIFICATEEMPLOYEELISTSUCCESS,
         payload: {
             err
         }
     })

 });
}
}

export function createCertificate (params, callback) {
    return (dispatch) => {
         certificateManagementService.createCertificate(params, (res) => {
             if (res.data.Success) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.CREATECERTIFICATESUCCESS,
                     payload: {
                         actionStatus: true,
                         // employeeList: res.data.Data
                     }
                 })
                 _util.successTips('创建证件成功')
                 if ('function' === typeof callback) {
                    callback(true)
                 }
             } else {
                 //throw new Error('创建证件失败')
                 throw new Error(res.data.Errors[0]);
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.CREATECERTIFICATEFAILURE,
                 payload: {
                     actionStatus: false
                 }
             })
             //_util.errorTips('创建证件失败')
             _util.errorTips(err.message);
         })
     }
}

export function updateCertificate (params, index, callback) {
    return (dispatch) => {
         certificateManagementService.updateCertificate(params, (res) => {
             if (res.data.Success) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.UPDATECERTIFICATESUCCESS,
                     payload: {
                        index: index,
                        value: params
                         // actionStatus: true,
                         // employeeList: res.data.Data
                     }
                 })
                 _util.successTips('修改证件成功')
                 if ('function' === typeof callback) {
                    callback(true);
                 }
             } else {
                 throw new Error('修改证件失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.UPDATECERTIFICATEFAILURE,
                 payload: {
                     actionStatus: false
                 }
             })
             _util.errorTips('修改证件失败')
         })
     }
}

export function deleteCertificate(deletes, callback) {
    return dispatch => {
        certificateManagementService.deleteCertificate(deletes, res => {
            if (res.data.Success && 'function' === typeof callback) {
                callback(true);
            }
        }, err => {})
    }
}

export function CertificatePost(posts) {
    return dispatch => {
        certificateManagementService.CertificatePost(posts, res => {

        }, err => {})
    }
}

// 通讯录

export function fetchAddressList(params) {
    return (dispatch) => {
         addressListService.fetchAddressList(params, (res) => {
             if (res.data) {
                 dispatch({
                     type: EmployeeManagement.ActionTypes.FETCHADDRESSDATA,
                     payload: {
                         addressList: res.data
                     }
                 })
             } else {
                 // 如何更好的抛出异常。。。。每次都 throw 一个 新构建的 Error 类 明显是 一个很糟糕的方案 Need to Think & Modify
                 throw new Error('获取信息失败')
             }
         }, (err) => {
             dispatch({
                 type: EmployeeManagement.ActionTypes.FETCHADDRESSFAILURE,
                 payload: {
                     err
                 }
             })
         })
     }
}

export function exportAddressList(params, callback){
    return (dispatch) => {
        addressListService.exportAddressList(params, (res) => {
            if(res.data.Success && 'function' === typeof callback) {
                callback(res.data.Message);
                // dispatch({
                //     type: EmployeeManagement.ActionTypes.EXPORTADDRESSLISTSUCCESS,
                //     payload: { url: res.message}
                // })
            } else {
                callback(false);
                // throw new Error('获取信息失败')
            }
        }, (err) => {
            callback(false);
            // dispatch({
            //     type: EmployeeManagement.ActionTypes.EXPORTADDRESSLISTFAILURE,
            //     payload: {
            //         err
            //     }
            // })
        })
    }
}

// 生日名单
export function fetchStaffBirthdayList(params){
    return (dispatch) => {
        staffBirthdayService.fetchStaffBirthdayList(params, (res) => {
            if(res.data) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.FETCHSTAFFBIRTHDAYLISTSUCCESS,
                    payload: {
                         birthdayList: res.data
                     }
                })
            } else {
                throw new Error('获取信息失败')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHSTAFFBIRTHDAYLISTFAILURE,
                payload: {
                    err
                }
            })
        })
    }
}

export function exportStaffBirthdayList(params, callback){
    return (dispatch) => {
        staffBirthdayService.exportStaffBirthdayList(params, (res) => {
            if(res.data.Success) {
                callback(res.data.Message);
                // dispatch({
                //     type: EmployeeManagement.ActionTypes.EXPORTSTAFFBIRTHDAYLISTSUCCESS,
                //     payload: { url: res.message}
                // })
            } else {
                throw new Error('导出生日列表失败')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.EXPORTSTAFFBIRTHDAYLISTFAILURE,
                payload: {
                    err
                }
            })
        })
    }
}


// 月度报表

export function fetchMonthlyReports (params) {
    return dispatch => {
        reportFormsService.fetchMonthlyReports(params, (res) => {
            if (res.data || res.data === null) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                    payload: {
                        monthlyReportsList: res.data ? res.data : [],
                        fileLocation: null
                    }
                })
            } else {
                throw new Error('后台接口有问题')
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHFAILURE,
                payload: {
                    err,
                    monthlyReportsList: []
                }
            })
        })
    }
}
export function exportMonthlyReports (params) {
    return dispatch => {
        reportFormsService.exportMonthlyReports(params, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                    payload: {
                        fileLocation: res.data.Message
                    }
                })
            } else if (res.data.Message) {
                _util.errorTips(`${res.data.Message}`)
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHFAILURE,
            })
        })
    }
}
export function emptyMonthlyReports (params) {
    return dispatch => {
        dispatch({
            type: EmployeeManagement.ActionTypes.EMPTY,
            payload: {
                fileLocation: null,
                monthlyReportsList: null
            }
        })
    }
}
export function fetchEmployeesReviewList (params) {
    return dispatch => {
        reportFormsService.fetchEmployeesReviewList(params, (res) => {
            if (res.data) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                    payload: {
                        employeesReviewList: res.data
                    }
                })
            } else {
                throw new Error(res.data.error)
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHFAILURE,
                payload: {
                    err
                }
            })
        })
    }
}
export function exportEmployeesMonthlyReportDetail (params) {
    return dispatch => {
        reportFormsService.exportEmployeesMonthlyReportDetail(params, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: EmployeeManagement.ActionTypes.FETCHSUCCESS,
                    payload: {
                        monthlyReportDetailFileUrl: res.data.Message
                    }
                })
                _util.successTips('导出成功')
            } else if (res.data.Message) {
                _util.errorTips(`${res.data.Message}`)
            }
        }, (err) => {
            dispatch({
                type: EmployeeManagement.ActionTypes.FETCHFAILURE,
            })
        })
    }
}
//机票补助
export function fetchAirticketSubsidyList(gets) {
 return dispatch => {
  airticketAllowanceService.selectAirticketAllowance(gets, res => {
   // console.log(res.data.Object.Data);
   dispatch({
    type: EmployeeManagement.ActionTypes.FETCHAIRTICKETSUBSIDYLISTSUCCESS,
    payload: {
     airticketPage: res.data.Page,
     airticketTotalPage:res.data.Total,
     airticketPageSize:res.data.PageSize,
     airticketData: res.data.Object.Data,
     airticketDataStatus: "loaded"
   }
 });
 }, err => {});
}
}
export function fetchHousingAllowanceList(gets) {
 return dispatch => {
  housingAllowanceService.selectHousingAllowance(gets, res => {
   // console.log(res);
   dispatch({
    type: EmployeeManagement.ActionTypes.FETCHHOUSINGALLOWANCELISTSUCCESS,
    payload: {
     housingPage: res.data.Page,
     housingPageSize: res.data.PageSize,
     housingTotalPage:res.data.Total,
     housingData: res.data.Object.Data,
     housingDataStatus: "loaded"
   }
 });
 }, err => {});
}
}
//合同管理中获取合同到期前接收提醒人员列表
export function fetchContractReceiveExpireMembers (params) {
	return dispatch => {
		contractManagementService.fetchContractReceiveExpireMembers(params, (res) => {
			if (res.data) {
				dispatch({
					type: EmployeeManagement.ActionTypes.FETCHCONTRACTRECEIVEEXPIREMEMBERSUSSESS,
					payload: {
						members_list: res.data
					}
				})
			}
		}, (err) => {
			dispatch({
				type: EmployeeManagement.ActionTypes.FETCHCONTRACTRECEIVEEXPIREMEMBEFAILURE,
				payload: {
					err
				}
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/actions/employee-management-actions.js